class SocialProofScroller extends HTMLElement {
  constructor() {
    super();
    this.inner = null;
    this.speed = 0.5;
    this.direction = 1; // 1 = scroll down (reveal more), -1 = scroll back up
    this.animationId = null;
    this.isPaused = false;
    this.isManual = false;
    this.manualTimeout = null;
  }

  connectedCallback() {
    this.inner = this.querySelector('.social-proof__scroll-inner');
    if (!this.inner) return;

    // Delay init to ensure layout is fully computed
    setTimeout(() => {
      var canScroll = this.inner.scrollHeight > this.inner.clientHeight + 2;
      if (!canScroll) return;
      this.startAutoScroll();
      this.bindEvents();
    }, 500);
  }

  disconnectedCallback() {
    this.stopAutoScroll();
    clearTimeout(this.manualTimeout);
  }

  bindEvents() {
    this.addEventListener('mouseenter', () => {
      this.isPaused = true;
    });

    this.addEventListener('mouseleave', () => {
      this.isPaused = false;
      this.isManual = false;
    });

    this.addEventListener('wheel', (e) => {
      e.preventDefault();
      this.isManual = true;
      this.inner.scrollTop += e.deltaY;
      clearTimeout(this.manualTimeout);
      this.manualTimeout = setTimeout(() => {
        this.isManual = false;
      }, 3000);
    }, { passive: false });

    var touchStartY = 0;
    this.addEventListener('touchstart', (e) => {
      touchStartY = e.touches[0].clientY;
      this.isManual = true;
    }, { passive: true });

    this.addEventListener('touchmove', (e) => {
      var deltaY = touchStartY - e.touches[0].clientY;
      touchStartY = e.touches[0].clientY;
      this.inner.scrollTop += deltaY;
    }, { passive: true });

    this.addEventListener('touchend', () => {
      clearTimeout(this.manualTimeout);
      this.manualTimeout = setTimeout(() => {
        this.isManual = false;
      }, 3000);
    });
  }

  startAutoScroll() {
    var self = this;

    function tick() {
      self.animationId = requestAnimationFrame(tick);

      if (self.isPaused || self.isManual) return;

      self.inner.scrollTop += self.speed * self.direction;

      var maxScroll = self.inner.scrollHeight - self.inner.clientHeight;

      if (self.direction === 1 && self.inner.scrollTop >= maxScroll - 1) {
        self.direction = -1;
      } else if (self.direction === -1 && self.inner.scrollTop <= 0) {
        self.direction = 1;
      }
    }

    self.animationId = requestAnimationFrame(tick);
  }

  stopAutoScroll() {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
      this.animationId = null;
    }
  }
}

if (!customElements.get('social-proof-scroller')) {
  customElements.define('social-proof-scroller', SocialProofScroller);
}
